export default __webpack_public_path__ + "static/media/power_spectrum_dynamic_norm.ce41aaa5.webp";